import React from "react";
import { Helmet } from "react-helmet-async";
import "./eventpage.css";
import EventDetails from "../../components/Event-details";

const Summer2026 = () => {
  return (
    <>
      <Helmet>
        <title>Bizarre Bazaar Summer Festival 2026 | July 4–5, Gigiri | Biz Baz Events</title>
        <meta
          name="description"
          content="Join Bizarre Bazaar Summer Festival, July 4–5 2026 at KSTVET, Gigiri. 200+ vendors, food court, live music, kids zone & DJ sets. Tickets from Kshs 200."
        />
        <meta property="og:title" content="Bizarre Bazaar Summer Festival 2026" />
        <meta
          property="og:description"
          content="200+ vendors, live music, food & culture — July 4–5, 2026 at KSTVET, Gigiri."
        />
        <meta property="og:image" content="https://Bizbazevents.com/images/posters/2024/Summer-2026-poster.png" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://Bizbazevents.com/events/summer-2026" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Event",
            name: "Bizarre Bazaar Summer Festival 2026",
            startDate: "2026-07-04T09:00",
            endDate: "2026-07-05T19:00",
            eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
            eventStatus: "https://schema.org/EventScheduled",
            location: {
              "@type": "Place",
              name: "KSTVET",
              address: {
                "@type": "PostalAddress",
                streetAddress: "UN Avenue",
                addressLocality: "Gigiri, Nairobi",
                addressCountry: "KE",
              },
            },
            image: ["https://Bizbazevents.com/images/posters/2024/Summer-2026-poster.png"],
            description:
              "A vibrant open-air festival with 200+ curated vendors, food court, brand activations, live performances, DJ sets, and a kids zone. Dog-friendly (on leash).",
            offers: {
              "@type": "Offer",
              url: "https://Bizbazevents.com/events/summer-2026",
              price: "500",
              priceCurrency: "KES",
              availability: "https://schema.org/InStock",
              validFrom: "2026-06-12",
            },
            organizer: {
              "@type": "Organization",
              name: "Biz Baz Events",
              url: "https://Bizbazevents.com",
            },
          })}
        </script>
      </Helmet>

      <div className="eventpage-container">
        <div
          className="event-hero"
          style={{ backgroundImage: "url('/images/REM00008.jpg')" }}
        />

        <div className="event-body-layout">
          <div className="event-body-main">
            <EventDetails
              description={
                <>
                  <p className="ep-intro">
                    Step into a vibrant, curated open-air festival where culture, creativity, food,
                    and entertainment collide. <strong>WHERE CULTURES CONNECT!!</strong> Shop a
                    curated mix of fashion 👗, accessories 👜, crafts 🧵, art 🎨, and unique
                    lifestyle finds — all in one place.
                  </p>

                  <p>
                    Fuel up at the buzzing food court and vendor bandas 🍔🍜🍹, catch Brand
                    Activations 🎯 from your favourite names, and experience Live Performances 🎶
                    all weekend long. Bring your people and spend the day the Biz Baz way. ✨
                  </p>

                  <p>🎪 <strong>What to Expect:</strong></p>
                  <ul>
                    <li>🔸 200+ curated vendors</li>
                    <li>🍲 Buzzing food court & vendor bandas</li>
                    <li>🎯 Brand Activations from your favourite names</li>
                    <li>🛍 An exciting mix of products across all price points</li>
                    <li>🎈 Kids Zone — keeping young festival-goers entertained</li>
                    <li>🎤 Live performances all weekend</li>
                    <li>🎧 DJ sets throughout the day</li>
                    <li>🐾 Dog-friendly event — dogs must be on a leash</li>
                  </ul>

                  <div className="event-access-grid">
                    <div className="event-access-badge eab--blue">
                      <span className="eab-icon">♿</span>
                      <span className="eab-label">Venue <br />Accessible</span>
                    </div>
                    <div className="event-access-badge eab--amber">
                      <span className="eab-icon">👪</span>
                      <span className="eab-label">Family<br />Friendly</span>
                    </div>
                    <div className="event-access-badge eab--green">
                      <span className="eab-icon">🦮</span>
                      <span className="eab-label">Dog Friendly<br />(on Leash)</span>
                    </div>
                  </div>
                </>
              }
              dateRange="July 4th & 5th, 2026"
              time={
                <ol style={{ listStyle: "none", listStylePosition: "inside", paddingLeft: "0" }}>
                  <li>Sat &amp; Sun: 9:00 AM – 7:00 PM</li>
                </ol>
              }
              location="KSTVET, UN Avenue, Gigiri"
              poster="/images/posters/2024/Summer-2026-poster.png"
              tickets={[
                "Daily Charge: Adults Kshs 500 | Under 18s Kshs 200",
                "Available on KenyaBuzz in advance or at the door",
              ]}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Summer2026;